import { render } from "./ConversationLog.vue?vue&type=template&id=2d94a1e4&scoped=true&lang=pug"
import script from "./ConversationLog.vue?vue&type=script&lang=js"
export * from "./ConversationLog.vue?vue&type=script&lang=js"

import "./ConversationLog.vue?vue&type=style&index=0&id=2d94a1e4&lang=scss&scoped=true"
import "./ConversationLog.vue?vue&type=style&index=1&id=2d94a1e4&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d94a1e4"]])

export default __exports__